module.exports = "<dashboard-compute-vc></dashboard-compute-vc>\n<main class=\"content-area\">\n    <router-outlet></router-outlet>\n</main>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/compute/compute-vc/compute-vc.html
// module id = Hjnv
// module chunks = 0